export const buyersSurvey = {
  'buyers_survey.continue': 'Pokračovat',
  'buyers_survey.skip': 'Přeskočit',
  'buyers_survey.send': 'Odeslat',
  'buyers_survey.loading': 'Probíhá načítání formuláře...',
  'buyers_survey.submit.error':
    'Při odesílání došlo k chybě, zkuste to prosím znovu za pár minut.',

  'buyers_survey.restore_previous.title':
    'Chcete pokračovat v rozpracovaném formuláři?',
  'buyers_survey.restore_previous.subtitle':
    'Máte rozpracovaný formulář na koupi, chcete v něm pokračovat nebo začít znovu?',
  'buyers_survey.restore_previous.estate_info': 'Jedná se o nemovitost:',
  'buyers_survey.restore_previous.continue': 'Pokračovat',
  'buyers_survey.restore_previous.cancel': 'Začít znovu',

  // Estate type
  'buyers_survey.flat': 'Byt',
  'buyers_survey.house': 'Dům',
  'buyers_survey.building_parcel': 'Pozemek',
  'buyers_survey.recreational_building': 'Chata',

  // Summary
  'buyers_survey.summary.estateType': `<b>Typ</b>: {estateType, select,
    flat {Byt}
    house {Dům}
    recreational_building {Chata}
    building_parcel {Stavební pozemek}
    other {Nemovitost}
   }`,
  'buyers_survey.summary.disposition': '<b>Dispozice</b>: {dispositions}',
  'buyers_survey.summary.disposition.unrestricted':
    '<b>Dispozice</b>: neomezeno',
  'buyers_survey.summary.area':
    '<b>Rozloha</b>: {area, select, undefined {Bez omezení} other {od {area} m<sup>2</sup>}}',
  'buyers_survey.summary.budget': '<b>Cena</b>:{budgetMin}{budgetMax}',
  'buyers_survey.summary.budget_min': ' od {budget}',
  'buyers_survey.summary.budget_max': ' do {budget}',
  'buyers_survey.summary.locality': '<b>Lokalita</b>: {locality}',

  'buyers_survey.success_bar.text': 'Sledování nabídek nastaveno',

  'buyers_survey.estate_count_bar.success':
    'Očekáváme, že najdeme <count></count> nemovitostí měsíčně',

  'buyers_survey.estate_count_bar.warn': `Očekáváme, že najdeme jen <count></count> {estateCount, plural,
      one {nemovitost}
      few {nemovitosti}
      other {nemovitostí}
    } měsíčně. <b>Doporučujeme rozšířit parametry.</b>`,

  'buyers_survey.estate_count_bar.error':
    'Očekáváme, že nenajdeme <b>žádné</b> nemovitosti. <b>Doporučujeme rozšířit parametry.</b>',

  // Unit dispositions
  'buyers_survey.unit_dispositions.1+kk': '1+KK',
  'buyers_survey.unit_dispositions.1+1': '1+1',
  'buyers_survey.unit_dispositions.2+kk': '2+KK',
  'buyers_survey.unit_dispositions.2+1': '2+1',
  'buyers_survey.unit_dispositions.3+kk': '3+KK',
  'buyers_survey.unit_dispositions.3+1': '3+1',
  'buyers_survey.unit_dispositions.4+kk': '4+KK',
  'buyers_survey.unit_dispositions.4+1': '4+1',
  'buyers_survey.unit_dispositions.larger': 'Větší',

  // Estate type step
  'buyers_survey.steps.estate_type.title': 'Jaký typ nemovitosti hledáte?',
  'buyers_survey.steps.estate_type.options.house': 'Dům',
  'buyers_survey.steps.estate_type.options.flat': 'Byt',
  'buyers_survey.steps.estate_type.options.recreational_building': 'Chata',
  'buyers_survey.steps.estate_type.options.building_parcel': 'Stavební pozemek',

  // Unit dispositions step
  'buyers_survey.steps.unit_dispositions.title': 'Chcete omezit dispozici?',
  'buyers_survey.steps.unit_dispositions.subtitle':
    'Zvolit můžete více možností',
  'buyers_survey.steps.unit_dispositions.title.tooltip':
    'První číslo udává počet místností, druhé číslo počet samostatných kuchyní. Zkratka kk značí kuchyňský kout, který je součástí jiné místnosti. Nejmenší dispozicí je garsoniéra (studio), značená 1+kk.',
  'buyers_survey.steps.unit_dispositions.required':
    'Vyberte prosím dispozice bytu',
  'buyers_survey.steps.unit_dispositions.skip': 'Přeskočit',

  // Parcel area step
  'buyers_survey.steps.parcel_area.title': 'Zadejte minimální rozměry pozemku',
  'buyers_survey.steps.parcel_area.label': 'Velikost pozemku v m<sup>2</sup>',
  'buyers_survey.steps.parcel_area.placeholder': 'Bez omezení',
  'buyers_survey.steps.parcel_area.required': 'Vyplňte prosím výměru pozemku',
  'buyers_survey.steps.parcel_area.positive':
    'Rozměr pozemku musí být kladná hodnota',
  'buyers_survey.steps.parcel_area.safe': 'Číslo je příliš vysoké',
  'buyers_survey.steps.parcel_area.skip': 'Přeskočit',

  // Locality step
  'buyers_survey.steps.locality.title': 'Zadejte lokalitu',
  'buyers_survey.steps.locality.label': 'Zadejte lokalitu',
  'buyers_survey.steps.locality.placeholder': 'např. okres, město nebo ulice',
  // radius
  'buyers_survey.steps.radius.title': 'Přidat okolí',
  'buyers_survey.steps.radius.placeholder': '{radius} km',
  'buyers_survey.steps.radius.null': 'Nezadáno',
  'buyers_survey.steps.radius.cta.back': 'Zrušit',
  'buyers_survey.steps.radius.cta.confirm': 'Potvrdit',

  // Locality confirmation step
  'buyers_survey.steps.confirm_locality.question': 'Je tato lokalita správná?',

  'buyers_survey.steps.confirm_locality.not_found.title':
    'Nenašli jsme žádnou lokalitu.',
  'buyers_survey.steps.confirm_locality.not_found.subtitle':
    'Zkuste to prosím znovu.',
  'buyers_survey.steps.confirm_locality.buttons.next': 'Ano, je správná',
  'buyers_survey.steps.confirm_locality.buttons.back': 'Upravit',

  'buyers_survey.steps.confirm_locality.title': `{type, select,
    flat {Byty}
    house {Domy}
    recreational_building {Chaty a chalupy}
    building_parcel {Stavební pozemky}
    other {Nemovitosti}
   } {radius, select,
    true {v okolí {localityType, select,
      street {ulice}
      cadastralArea {katastrálního území}
      momc {městské části}
      municipality {obce}
      district {okresu}
      region {kraje}
      other {}
    }}
    false {{localityType, select, 
      street {v ulici}
      cadastralArea {v katastrálním území}
      momc {v městské části}
      municipality {v obci}
      district {v okresu}
      region {v kraji}
      other {}}}
    other {}
  } {name}`,

  // Email step
  'buyers_survey.steps.email.title': `Vaše hlídání nabídek {estateType, select,
      house {domů}
      flat {bytů}
      recreational_building {chat}
      building_parcel {stavebních pozemků}
      other {nemovitostí}
    } je připravené`,
  'buyers_survey.steps.email.label': 'Email pro zasílaní nových nabídek',
  'buyers_survey.steps.email.placeholder': 'Váš email',
  'buyers_survey.steps.email.required': 'Vyplňte prosím platný e-mail',
  'buyers_survey.steps.email.cta': 'Začít hlídání nabídek',
  'buyers_survey.steps.email.text':
    'Vaše údaje jsou u nás v bezpečí. Odesláním souhlasíte se <gdpr>zpracováním osobních údajů</gdpr>.',

  // Budget step
  'buyers_survey.steps.budget.title': 'Chcete omezit cenu?',
  'buyers_survey.steps.budget.positive': 'Rozpočet musí být kladná hodnota',
  'buyers_survey.steps.budget.not_less_than_min_budget':
    'Horní hranice ceny nesmí být menší než spodní',
  'buyers_survey.steps.budget.not_negative':
    'Rozpočet nesmí být záporná hodnota',
  'buyers_survey.steps.budget.safe': 'Číslo je příliš vysoké',
  'buyers_survey.steps.budget.min.label': 'Od',
  'buyers_survey.steps.budget.max.label': 'Do',
  'buyers_survey.steps.budget.warn':
    'Podle vašeho rozpočtu to vypadá, že nehledáte nemovitost na koupi ale na pronájem. Takovou službu bohužel zatím nenabízíme.',

  // Frequency step
  'buyers_survey.steps.frequency.title':
    'Jak často chcete posílat nemovitosti?',
  'buyers_survey.steps.frequency.required':
    'Vyplňte prosím frekvenci zasílání.',
  'buyers_survey.steps.frequency.options.hourly': 'Každou hodinu',
  'buyers_survey.steps.frequency.options.daily': 'Denně',
  'buyers_survey.steps.frequency.options.weekly': 'Týdně',

  // Financing step
  'buyers_survey.steps.financing.title':
    'Máte zájem o hypotéku s nejvýhodnějším úrokem?',

  // Financing step B
  'buyers_survey.steps.financing_b.title':
    'Získejte náskok před ostatními zájemci díky připravené hypotéce',
  'buyers_survey.steps.financing_b.sub_title':
    '1 ze 3 zájemců příjde o vysněnou nemovitost, protože řeší hypotéku pozdě. Zvýšíme vaše šance.',
  'buyers_survey.steps.financing_b.info1': 'Zjistíte kolik si můžete dovolit',
  'buyers_survey.steps.financing_b.info2':
    'Poradíme vám jak získat nejvýhodnější úrok',
  'buyers_survey.steps.financing_b.info3': 'Provedeme vás celým procesem',
  'buyers_survey.steps.financing_b.cta.no_thanks': 'Ne, děkuji',
  'buyers_survey.steps.financing_b.cta.wants_mortgage': 'Spočítat hypotéku',

  // Contact page
  'buyers_survey.steps.contact.title':
    'Pro získání nejvýhodnější úrokové sazby zadejte kontaktní údaje',
  'buyers_survey.steps.contact.subtitle':
    'Pro zjištění možné výše hypotéky zadejte kontaktní údaje a náš specialista se s vámi spojí a představí vám vaše možnosti.',
  'buyers_survey.steps.contact.fullName': 'Jméno a příjmení',
  'buyers_survey.steps.contact.fullName.required':
    'Vyplňte prosím vaše celé jméno',
  'buyers_survey.steps.contact.phone': 'Telefon',
  'buyers_survey.steps.contact.phone.required': 'Vyplňte prosím váš telefon',
  'buyers_survey.steps.contact.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'buyers_survey.steps.contact.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',
  'buyers_survey.steps.contact.cta': 'Získat nejvýhodnější úrok',

  'buyers_survey.steps.contact.b.title':
    'Pro výpočet hypotéky zadejte kontaktní údaje',
  'buyers_survey.steps.contact.b.cta': 'Spočítat hypotéku',
  'buyers_survey.steps.contact.b.skip': 'Nechci spočítat hypotéku',

  // Wants estimate step
  'buyers_survey.steps.wants_estimate.title':
    'Chtěli byste zjistit aktuální cenu své nemovitosti online?',
  'buyers_survey.steps.wants_estimate.options.yes': 'Ano',
  'buyers_survey.steps.wants_estimate.options.no_estate':
    'Nevlastním nemovitost',
  'buyers_survey.steps.wants_estimate.options.no': 'Ne',

  // Wants estimate step B
  'buyers_survey.steps.wants_estimate_b.title':
    'Zjistěte cenu své nemovitosti online',
  'buyers_survey.steps.wants_estimate_b.info1': 'Zdarma, z pohodlí domova',
  'buyers_survey.steps.wants_estimate_b.info2': 'Do tří minut máte jasno',
  'buyers_survey.steps.wants_estimate_b.info3':
    'Můžete sledovat vývoj ceny své nemovitosti',
  'buyers_survey.steps.wants_estimate_b.cta.no_thanks': 'Ne, děkuji',
  'buyers_survey.steps.wants_estimate_b.cta.wants_estimate': 'Spočítat odhad',

  // Thank you step
  'buyers_survey.steps.thank_you.title': 'Hlídání nabídek nastaveno',
  'buyers_survey.steps.thank_you.subtitle':
    'Na adresu <b>{email}</b> budete pravidelně dostávat nové nabídky',
  'buyers_survey.steps.thank_you.new_survey_cta': 'Nastavit další hlídání',
};
